export const BRAINTREE_FIELD_IDS = {
  CARD_NUMBER: 'braintree-card-number',
  EXPIRATION_DATE: 'braintree-expiration-date',
  CVV: 'braintree-cvv',
  CARDHOLDER_NAME: 'braintree-cardholder-name',
} as const;

export const BRAINTREE_FIELD_CONFIG = {
  number: {
    selector: `#${BRAINTREE_FIELD_IDS.CARD_NUMBER}`,
    placeholder: 'Card Number',
  },
  expirationDate: {
    selector: `#${BRAINTREE_FIELD_IDS.EXPIRATION_DATE}`,
    placeholder: 'MM/YY',
  },
  cvv: {
    selector: `#${BRAINTREE_FIELD_IDS.CVV}`,
    placeholder: 'CVV',
  },
  cardholderName: {
    selector: `#${BRAINTREE_FIELD_IDS.CARDHOLDER_NAME}`,
    placeholder: 'Cardholder Name',
  },
} as const;

export const BRAINTREE_STYLES = {
  input: {
    'font-size': '14px',
    color: 'inherit',
    padding: '12px 8px',
  },
  'input:focus': {
    outline: 'none',
  },
  ':focus': {
    'border-color': 'var(--color-muted-foreground, #71717A)',
  },
  ':active': {
    'border-color': 'var(--color-muted-foreground, #71717A)',
  },
  '::placeholder': {
    color: 'rgb(156, 163, 175)',
  },
} as const;

export const BRAINTREE_ERROR_CODES = {
  DUPLICATE_IFRAME: 'HOSTED_FIELDS_FIELD_DUPLICATE_IFRAME',
  TIMEOUT: 'HOSTED_FIELDS_TIMEOUT',
} as const;

export const BRAINTREE_HOSTED_FIELD_NAMES = {
  CARD_NUMBER: 'number',
  EXPIRATION_DATE: 'expirationDate',
  CVV: 'cvv',
} as const;

export const BRAINTREE_DOM_READY_DELAY = 100;

// IMPORTANT: braintree-web is pinned exactly to 3.118.0 in package.json.
// Two regressions exist in later versions that break the Venmo flow inside
// an iframe-embedded checkout on Android Chrome:
//   - 3.118.1 changed `appSwitch` to use `window.location.href = url` on
//     Android Chrome unconditionally. Inside an iframe, this navigates the
//     iframe to `account.venmo.com` ("get the app" page) instead of opening
//     the native Venmo app, because cross-origin iframes cannot deep-link.
//     3.126.0 made the new branch opt-in via `mobileWebFallBack: true`, so
//     3.126+ with `mobileWebFallBack: false` would route through window.open
//     again — except that:
//   - 3.125.0 added an auto-cancel inside `_pollForStatusChange`: the SDK
//     now stores `_venmoWindow = window.open(url)` and, on the first
//     post-app-switch poll where status is still CREATED and `_venmoWindow.
//     closed === true`, issues `UpdateVenmoPaymentContextStatus → CANCELED`
//     and rejects tokenize() with VENMO_MOBILE_POLLING_TOKENIZATION_CANCELED
//     before the user's APPROVED status arrives. No config flag disables it.
// 3.118.0 has neither problem and includes ~6 months of fixes over v2's
// 3.112.0 (Kount deprecation, 3DS Songbird URL, Local Payment redirect,
// Hosted Fields). Do not bump until Braintree fixes both regressions.
export const VENMO_CONFIG = {
  allowNewBrowserTab: false,
  allowDesktop: true,
  allowDesktopWebLogin: false,
  paymentMethodUsage: 'multi_use' as 'multi_use' | 'single_use',
};
